// =============================
// File: src/Login.jsx (JSX)
// =============================
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";

const API_LOGIN = `${API}/api/login`;

export function Login({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(API_LOGIN, { email, password });
      // Persist tokens & user payload
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("username", data.username);
      localStorage.setItem("email", data.email);
      localStorage.setItem("phone_number", data.phone_number);
      localStorage.setItem("role", data.role);
      localStorage.setItem("providerId", data.provider_id);
      localStorage.setItem("addresses", JSON.stringify(data.addresses || []));

      onLoginSuccess?.(data.user_id, data.username, data.email, data.phone_number, data.role, data.addresses, data.provider_id);
      navigate("/");
    } catch (err) {
      const msg = err?.response?.data?.message || "Credenciales inválidas";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm border border-slate-200">
        <h1 className="text-2xl font-extrabold" style={{ color: "#B1336E" }}>Iniciar sesión</h1>
        <p className="mt-1 text-sm text-slate-600">Accede a tu panel para gestionar entregas.</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Correo</label>
            <input
              type="email"
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              placeholder="tucorreo@empresa.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium">Contraseña</label>
            <input
              type="password"
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700 border border-red-200">{error}</div>}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl px-4 py-2.5 font-semibold text-white shadow-sm disabled:opacity-60"
            style={{ background: "#B1336E" }}
          >
            {loading ? "Ingresando…" : "Ingresar"}
          </button>
        </form>

        <div className="mt-4 text-sm text-slate-600">
          ¿No tienes cuenta? {" "}
          <Link to="/register" className="font-semibold underline underline-offset-4">Crear cuenta</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;